var _toArray = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports"], b);else if ("undefined" != typeof exports) b(exports);else {
    var c = {
      exports: {}
    };
    b(c.exports), a.objectGet = c.exports;
  }
})(this, function (a) {
  "use strict";

  function b() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var c = arguments.length > 1 ? arguments[1] : undefined;

    var _$split = "".concat(c).split(/\./),
        _$split2 = _toArray(_$split),
        d = _$split2[0],
        e = _$split2.slice(1),
        f = a[d];

    return e.length ? b(f, e.join(".")) : f;
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = b;
});